import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import { Card } from 'react-components'

import { CardContentContainer, PrimaryFAQCardContainer, TitleContainer } from './primary-faq-card-styles'
import { PrimaryFAQTransport } from '@common/transports/deprecated-home-page-transport'
import RoundIcon from './round-icon'
import PrimaryFAQButton from './primary-faq-button'

interface PrimaryFAQCardProps {
    faq: PrimaryFAQTransport
}

const PrimaryFAQCard: React.FC<PrimaryFAQCardProps> = ({ faq: { image, title, button } }) => {
    const theme = useContext(ThemeContext)

    return (
        <PrimaryFAQCardContainer>
            <Card
                backgroundColor={theme.colors.white}
                borderRadius={theme.typography.border.radius.small}
                shadowed
                boxShadow={`0 ${theme.spacing.xxxSmall} ${theme.spacing.small} 0 #00000026`}
            >
                <CardContentContainer>
                    <RoundIcon image={image} backgroundColor={`${theme.colors.tfwBlue}26`} radius="3.125rem" />
                    <TitleContainer>{title}</TitleContainer>
                    <PrimaryFAQButton button={button} />
                </CardContentContainer>
            </Card>
        </PrimaryFAQCardContainer>
    )
}

export default PrimaryFAQCard
